import request from '@/utils/request'

export function userCollect(data) {
    return request({
      url: 'product/userCollect',
      method: 'post',
      data
    })
  }
  